import initExitPopup from 'landings/__assets__/scripts/components/exit-popup'

initExitPopup()
